import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a75dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "mt-2 mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Usuário", -1))
const _hoisted_5 = { class: "mt-2 mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Senha", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "link-forgot-password" }, "Esqueceu sua senha?", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Entrar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginHeader = _resolveComponent("LoginHeader")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginHeader),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.loginAction(_ctx.login, _ctx.password)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            name: "login",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event)),
            class: "form-input",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.login]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            name: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            class: "form-input",
            type: "password"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ])
        ]),
        _createElementVNode("div", {
          class: "forgot-password mt-2 mb-4",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
        }, _hoisted_8),
        _createVNode(_component_BaseButton, {
          customClass: "form-button",
          type: "submit",
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 0,
                  name: "spinner",
                  color: "#000"
                }))
              : _createCommentVNode("", true),
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 32)
    ])
  ]))
}